import { render, staticRenderFns } from "./BasicElements.vue?vue&type=template&id=551a5478&"
import script from "./BasicElements.vue?vue&type=script&lang=js&"
export * from "./BasicElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports